import React from "react";
import { toast } from "react-toastify";
import { Badge } from "react-bootstrap";
import { getCustomerServices } from "../services/servicesService";
import { getMyEquipments } from "../services/equipmentService";
import { getTariffsForCustomer } from "../services/tariffService";
import FormComponent from "./common/formComponent";
import { getCurrentUser } from "../services/authService";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PageLoading from "./common/pageLoading";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";

class MyServices extends FormComponent {
  state = {
    customerId: getCurrentUser()._id,
    errors: {},
    action: "modify",
    equipments: [],
    services: [],
    tariffs: [],
    serviceToModify: {},
    loading: "",
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    await this.populateEquipments();
    await this.populateServices();
    await this.populateTariffs();
  }

  async populateEquipments() {
    try {
      const { data: equipments } = await getMyEquipments();
      this.setState({ equipments });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateTariffs() {
    const { customerId } = this.state;

    try {
      const { data: tariffs } = await getTariffsForCustomer(customerId);
      this.setState({ tariffs });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async populateServices() {
    const { equipments } = this.state;

    let equipmentIds = "";
    for (var i = 0; i < equipments.length; i++) {
      const id = equipments[i]._id;
      equipmentIds += id + ",";
    }

    try {
      const { data: services } = await getCustomerServices(equipmentIds);
      this.setState({ services });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  render() {
    const { services, loading } = this.state;
    return (
      <React.Fragment>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div>
                <h5>My Services</h5>
              </div>
            </div>
            <div className="card-body">
              <span className="card-text">
                {loading && <PageLoading loading={loading} />}
                {loading === false && services.length === 0 && <span>No Services to Display</span>}
                {loading === false && services.length > 0 && (
                  <TableContainer component={Paper} className="mt-4">
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Tariff</StyledTableCell>
                          <StyledTableCell align="right">Equipment</StyledTableCell>
                          <StyledTableCell align="right">Start Date</StyledTableCell>
                          <StyledTableCell align="right">End Date</StyledTableCell>
                          <StyledTableCell align="right">Type</StyledTableCell>
                          <StyledTableCell align="right">Status</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {services.map((service) => (
                          <StyledTableRow key={service._id}>
                            <StyledTableCell component="th" scope="row">
                              {service.tariff}
                            </StyledTableCell>
                            <StyledTableCell align="right">{service.equipment}</StyledTableCell>
                            <StyledTableCell align="right">{service.formattedStartDate}</StyledTableCell>
                            <StyledTableCell align="right">{service.formattedEndDate}</StyledTableCell>
                            <StyledTableCell align="right">{service.type}</StyledTableCell>
                            <StyledTableCell align="right">
                              <Badge variant={`${service.status === "Active" ? "success" : "danger"}`}>
                                {service.status}
                              </Badge>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </span>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
}

export default MyServices;
